module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fiFae"))).then(() => parcelRequire('ljYL6'));